module.exports = __webpack_public_path__ + "static/media/img10.fdc5ba2f.JPG";